module.exports = __webpack_public_path__ + "media/MRI8-ad.39cde9b6.mp3";